import React, {useState} from 'react';
import "./Accordion.scss";
import arrow from "../../img/faqArrow.svg";

function Accordion({items}) {
	const [selected, setSelected] = useState(null);

	const handleToggle = (index) => {
		setSelected(selected === index ? null : index);
	};

	return (
		<div className="accordion-wrap">
			{items.map((item, i) => (
				<div className="accordion-item" key={i} onClick={() => handleToggle(i)}>
					<div className="accordion-title">
						<h4>{item.title}</h4>
						<img className={selected === i ? "spin" : ""} src={arrow} alt=""/>
					</div>
					<div className={selected === i ? "accordion-content active" : "accordion-content"}>
						<div onClick={e => e.stopPropagation()}>
							{item.content}
						</div>
					</div>
				</div>
			))}
		</div>
	);
}

export default Accordion;
